import { render, staticRenderFns } from "./lights.vue?vue&type=template&id=03751e4e&"
import script from "./lights.vue?vue&type=script&lang=js&"
export * from "./lights.vue?vue&type=script&lang=js&"
import style0 from "./lights.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports